<script lang="ts">
	import { onMount } from 'svelte';
	import ThreeCanvas from "./ThreeCanvas.svelte";
    import TWEEN from '@tweenjs/tween.js';
    import Loader from './Loader.svelte';
    import type { EasingFunction } from 'svelte/types/runtime/transition';
    import { Cube } from '../obj/Cube';
    import { getAniProps } from "../utils/CubeUtils"; 
    import * as THREE from 'three';
    import VideoTag from './VideoTag.svelte';
	export let texturePaths:string[];

	let mouse = { x: 0, y: 0 };
	let frame:number
    let video:HTMLVideoElement;
    let loadedProgress:number = 0;


    const totalW:number = 700;
	const totalH:number = 528;
    const gridSizes:number[][] = [[1, 8], [8, 8], [16, 16]];
    let cubeSizes = [];
    for (let i = 0; i < gridSizes.length; i++) {
        cubeSizes[i] = [totalW / gridSizes[i][0], totalH / gridSizes[i][1]];
    }
    let cubeCounts = [];
    for (let i = 0; i < gridSizes.length; i++) {
        cubeCounts[i] = [gridSizes[i][0] * gridSizes[i][1]];
    }
	let cubes:Cube[][] = [];

    let totalCubes = 0;
    for (let i = 0; i < gridSizes.length; i++) {
        cubes[i] = [];
        for (let j = 0; j < cubeCounts[i]; j++) {
            cubes[i][j] = new Cube(i+1, 0, 0, 0);
            totalCubes++;
        }
    }
    console.log("Total Cubes: " + totalCubes);

    initCubeGrid(12, 6);

    mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
        c.cue.z = -850;
        c.position.z = 1100;
    });

    let loadManager = new THREE.LoadingManager();
    const loader = new THREE.TextureLoader(loadManager);
	let textures:THREE.Texture[] = [];

    for (let i = 0; i < texturePaths.length; i++) {
        textures[i] = loader.load(texturePaths[i]);
    }

    loadManager.onLoad = () => {
        document.getElementById( 'loading' ).style.opacity = "0";
        document.getElementById( 'svelteCanvas' ).style.opacity = "1";
        
        mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
            c.position.z = 1100 + (Math.random() * 400);
        });
        animate1();
    }

    let groupObjects:THREE.Object3D[] = [];
    for (let i = 0; i < 16; i++) {
        groupObjects[i] = new THREE.Object3D();
    }
    
	let objects:THREE.Object3D[] = [];
    let light1 = new THREE.PointLight(0xC1C1C1);
    light1.position.z = 80;
    objects.push(light1);
    objects.push(new THREE.AmbientLight (0x656565));
    // objects.push(new THREE.AmbientLight (0xffffff));


    let material = new THREE.MeshPhongMaterial({ map: textures[2], emissive: 0x000000  });
    let bkgPlane = new THREE.Mesh( new THREE.PlaneGeometry( 1222, 80, 1, 1 ), material ); 
    bkgPlane.position.set( 0, 0, 0 );
    // objects.push(bkgPlane);

    let camera:THREE.Camera;
	camera = new THREE.PerspectiveCamera( 40, window.innerWidth / window.innerHeight, 1, 10000 );
    camera.position.z = 1020;

    // ----------------------------------------


	
    setCubeGroupVisible(1, true);
    setCubeGroupVisible(2, true);

    let aniProps:any = getAniProps();
    aniProps.cubeIndexs = [];
    aniProps.cubeIds = [];
    aniProps.separateZ = true;
    aniProps.duration = 1300;
    tweenCubes(aniProps);

    let timeDelay = 500;
    let groupRotY = -1;


    function animate1(){

        setTimeout(() => {
            const yFlipDelay = 90;
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cueRot.y = Math.PI * -4;
                c.delay = (cube * 25) + 40 + (Math.random()*350);
                c.interact = 0;
                if(Math.random() > .97){c.setRanCuePos(1400, 0, 100)};
            });

            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cue.z -= 20;
            }, 1);
            if(groupRotY % 2 == 0){
                mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                    c.cue.z -= 140;
                    c.delay = (cube * 13) - (Math.random() * 290);
                }, 3);

            }

            aniProps = getAniProps();
            aniProps.cubeIndexs = [];
            aniProps.cubeIds = [];
            // aniProps.separateZ = true;
            aniProps.duration = 800;
            aniProps.instanced = !true;
            const ranHue = Math.random();
            aniProps.onUpdate = ((c:Cube) => {updateHsl(c, c.rotation.y - ranHue);});

            groupRotY -= 2;
            tweenCubes(aniProps);

            for (let i = 0; i < groupObjects.length; i++) {
                const coords = {sy: groupObjects[i].rotation.y};
                let targetProps = {sy: Math.PI * groupRotY};
                const tween = new TWEEN.Tween(coords) 
                        .to(targetProps, 1400) 
                        .easing(TWEEN.Easing.Quadratic.InOut)
                        .delay(((groupObjects.length-i+3) * yFlipDelay) + 2000)
                        .onUpdate(() => {
                            groupObjects[i].rotation.y = coords.sy;
                        })
                        .start();
            }
            
        }, timeDelay);
        timeDelay += 4400;


        setTimeout(() => {
            initCubeGrid(6, 6);
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.delay = (xI * 70) + (yI * 28) + (Math.random()*600);
                c.interact = 0;
                if(groupRotY % 2 == 0){
                }else{
                    if(Math.random() > .9){
                        c.setRanCuePos(1900, 0, 100);
                        c.delay = Math.random() * 300;
                    };
                }
            });
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cue.z -= 20;
            }, 1);
            aniProps.duration = 1900;
            aniProps.instanced = !true;
            tweenCubes(aniProps);
        }, timeDelay);
        setTimeout(() => {
            // setCubeGroupVisible(2, !true);
        }, timeDelay+210);
        timeDelay += 1800;
            groupRotY -= 1;
        if(groupRotY % 2 == 0){
            timeDelay += 1200;
        }


        setTimeout(() => {
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cueRot.x = Math.PI * 2;
                c.delay = (xI * 50) + (yI * 50) + 140;
                c.interact = 0;
            });
            aniProps.zActive = !true;
            aniProps.duration = 700;
            aniProps.stopPrevious = true;
            aniProps.onComplete = ((c:Cube) => {c.resetHsl();});
            tweenCubes(aniProps);

        }, timeDelay);
        timeDelay += 2200;
        if(groupRotY % 2 == 0){
            timeDelay += 2200;
        }


        setTimeout(() => {
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cueRot.x = Math.PI * 4;
                c.delay = ((6-xI) * 70) + ((8-yI) * 70);
                c.interact = 0;
                if(Math.random() > .9){c.cue.z += Math.random() * 350;}
            }, 2);

            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                let l1 = .7;
                if(groupRotY % 2 == 0){
                    c.setRanCuePos(4, 4, 0); c.setRanCueRot(l1, l1, 0);
                }else{
                    c.setRanCuePos(4, 0, 100);
                }
                if(Math.random() > .95){c.cue.z += Math.random() * 200;}
            });
            aniProps.duration = 600;
            aniProps.instanced = true;
            aniProps.zActive = true;
            aniProps.onUpdate = ((c:Cube) => {updateHsl(c, c.rotation.x);});
            tweenCubes(aniProps);

            for (let i = 0; i < groupObjects.length; i++) {
                const coords = {sy: groupObjects[i].rotation.y};
                let targetProps = {sy: Math.PI * groupRotY};
                const tween = new TWEEN.Tween(coords) 
                        .to(targetProps, 2400) 
                        .easing(TWEEN.Easing.Quadratic.InOut)
                        .delay(((groupObjects.length-i+3) * 100) + 300)
                        .onUpdate(() => {
                            groupObjects[i].rotation.y = coords.sy;
                        })
                        .start();
            }
            groupRotY -= 2;
        }, timeDelay);
        timeDelay += 800;
        
        if(groupRotY % 2 == 0){
            timeDelay += 1400;
        }


        setTimeout(() => {
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cueRot.x = Math.PI * -2;
                c.delay = ((xI) * 120) + ((yI) * 180);
                c.interact--;
            }, 1);

            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.interact = 0;
                if(Math.random() > .95){c.cue.z += Math.random() * 200;}
            });
            if(groupRotY % 2 == 0){
                
            }else{
                initCubeGrid(6, 0);
                mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                    c.cue.z += (Math.random() * 200) + 50;
                }, 2);
                mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                    c.cue.z += (Math.random() * 20) + 120;
                    c.cue.z -= 100;
                });
            }
            aniProps.instanced = !true;
            aniProps.duration = 1200;
            aniProps.stopPrevious = !true;
            aniProps.onUpdate = ((c:Cube) => {updateHsl(c, c.rotation.y);});
            tweenCubes(aniProps);

        }, timeDelay);
        timeDelay += 2000;

        if(groupRotY % 2 == 0){
            setTimeout(() => {
                let ranV = (Math.random() * 300) + 60;
                if(groupRotY % 2 == 0){
                    ranV *= -1;
                }
                
                mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                    c.cue.z = ranV;
                    c.interact--;
                });
                mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                    c.setRanCuePos(300, 0, 100);
                }, 3);
                    
                aniProps.instanced = true;
                tweenCubes(aniProps);
                
            }, timeDelay);
            timeDelay += 500;
        }else{
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cue.z -= 100;
                c.setRanCuePos(300, 300, 50);
            }, 3);
            mapToCubes((c:Cube, grid:number, cube:number, xI:number, yI:number) => {
                c.cue.z -= 100;
                c.setRanCuePos(300, 300, 50);
            }, 2);
            tweenCubes(aniProps);
            timeDelay += 600;
        }

        setTimeout(() => {
            timeDelay = 100;
            animate1();
        }, timeDelay);

    }


    // ----------------------------------


    let frameCount = 0;
	onMount(() => {
        /*video = document.getElementById( 'video' ) as HTMLVideoElement;
        video.currentTime = 41;
        video.addEventListener('canplaythrough', (event:Event) => {
            checkIfCanPlay();
        });*/

        (function loop(time) {
			frame = requestAnimationFrame(loop);
            TWEEN.update(time);
            
            animateCubes();
            frameCount++;
		}());
		return () => { cancelAnimationFrame(frame); };
    });

	function animateCubes():void{
	}

    function handleMousemove(event: MouseEvent) {
        mouse.x = Math.min( event.clientX / window.innerWidth, 1);
        mouse.y = event.clientY / window.innerHeight;
    }
/*
    function checkIfCanPlay(){
        loadedProgress++;
        if(loadedProgress > 0){startPlayback();}
    }
    function startPlayback(){
        video.play();
        document.getElementById( 'loading' ).style.opacity = "0";
    }*/

    /////////////////////////////////////////////////////////////////////////


	function tweenCubes(aniProps:any):void{
        if(aniProps.cubeIndexs.length < 1){
            for (let u = 0; u < gridSizes.length; u++) {
                aniProps.cubeIndex = u+1;
                tweenCubesSingleIndex(aniProps);
            }
        }else{
            for (let u = 0; u < aniProps.cubeIndexs.length; u++) {
                aniProps.cubeIndex = aniProps.cubeIndexs[u];
                tweenCubesSingleIndex(aniProps); 
            }
        }
    }

	function tweenCubesSingleIndex(aniProps:any):void{
        let cubeId = 0;
        if(aniProps.cubeIds.length < 1){
            for (let u = 0; u < cubeCounts[aniProps.cubeIndex-1]; u++) {aniProps.cubeIds[u] = u+1;}
        }
        if(aniProps.cubeIndex < 1 || aniProps.cubeIndex > gridSizes.length){return;}
        for (let i = 0; i < aniProps.cubeIds.length; i++) {
            cubeId = aniProps.cubeIds[i];
            if(cubeId > 0 && cubeId <= cubeCounts[aniProps.cubeIndex-1]){
                const c = cubes[aniProps.cubeIndex-1][cubeId-1];
                const coords = {x: c.position.x, y: c.position.y, z: c.position.z,
                    rx: c.rotation.x, ry: c.rotation.y, rz: c.rotation.z,
                    sx: c.scale.x, sy: c.scale.y, sz: c.scale.z};
                let targetProps = {
                    x: c.cue.x+aniProps.x, y: c.cue.y+aniProps.y, z: c.cue.z+aniProps.z,
                    rx: c.cueRot.x, ry: c.cueRot.y, rz: c.cueRot.z,
                    sx: c.cueScale.x,sy: c.cueScale.y, sz: c.cueScale.z
                };
                if(aniProps.stopPrevious && c.tween){c.tween.stop();}

                if(c.interact < 1){
                    let cDelay = c.delay;
                    if(aniProps.delay){cDelay += aniProps.delay;}
                    const tween = new TWEEN.Tween(coords) 
                        .to(targetProps, Math.max(0, aniProps.duration+c.durationOffset)) 
                        .easing(aniProps.ease)
                        .delay(Math.max(0, cDelay))
                        .onUpdate(() => {
                            if(aniProps.xActive){c.position.x = coords.x;}
                            if(aniProps.yActive){c.position.y = coords.y;}
                            if(aniProps.zActive && !aniProps.separateZ){ c.position.z = coords.z; }
                            if(aniProps.rxActive){c.rotation.x = coords.rx;}
                            if(aniProps.ryActive){c.rotation.y = coords.ry;}
                            if(aniProps.rzActive){c.rotation.z = coords.rz;}
                            if(aniProps.sxActive){c.scale.x = coords.sx;}
                            if(aniProps.syActive){c.scale.y = coords.sy;}
                            if(aniProps.szActive){c.scale.z = coords.sz;}
                            if(aniProps.onUpdate){aniProps.onUpdate(c);}
                        })
                        .onComplete(() => {
                            if(aniProps.onComplete){aniProps.onComplete(c);}
                        }).start();

                    if(!aniProps.instanced){c.tween = tween;}
                    if(aniProps.zActive && aniProps.separateZ){
                        if(aniProps.stopPreviousZ && c.tweenZ){c.tweenZ.stop();}
                        const zDelay = 250;
                        const tweenZ = new TWEEN.Tween(coords) 
                            .to({z: c.cue.z+aniProps.z}, Math.max(0, aniProps.duration+c.durationOffset - zDelay)) 
                            .easing(aniProps.easeZ)
                            .delay(Math.max(0, cDelay + zDelay))
                            .onUpdate(() => {
                                c.position.z = coords.z;
                            }).start();
                        
                        if(!aniProps.instanced){ c.tweenZ = tweenZ;}
                    }
                }
            }
        }aniProps.cubeIds = [];
    }

	function initCubeGrid(xGap?:number, yGap?:number, dimensions?:number[]):void{
		let count:number = 0;
        let xs:number = (xGap) ? xGap : 0;
        let ys:number = (yGap) ? yGap : 0;
        let xStack:number = 0; let yStack:number = 0;
        for (let u = 0; u < gridSizes.length; u++) {
            const xgrid:number = gridSizes[u][0];
            const ygrid:number = gridSizes[u][1];
            let cubeW:number = cubeSizes[u][0];
            let cubeH:number = cubeSizes[u][1];
            let diffW:number;
            let diffH:number;
            if(dimensions){
                cubeW = dimensions[0] / xgrid;
                cubeH = dimensions[1] / ygrid;
                diffW = dimensions[0] / totalW;
                diffH = dimensions[1] / totalH;}
            let modulX:number = xgrid / 8;
            let modulY:number = ygrid / 4;
            for (let i = 0; i < xgrid; i++) {
                for (let j = 0; j < ygrid; j ++) {
                    const x = ((i - xgrid / 2) * cubeW) + cubeW * .5 - (xs * 1.75);
                    const y = ((j - ygrid / 2) * cubeH) + cubeH * .5 - (ys * 3.5);
                    const c:Cube = cubes[u][count];
                    c.cue.set(x + xStack, y + yStack, 0);
                    if(dimensions){
                        c.cueScale.x = diffW;
                        c.cueScale.y = diffH;}
                    if(!c.grid){
                        c.grid = new THREE.Vector3();
                        c.grid.copy(c.cue);}
                    if(j % modulX == modulX-1){yStack += ys;} count++;
                }
                if(i % modulY == modulY-1){xStack += xs;}yStack = 0;
            }xStack = 0;count = 0;
        }
	}

    function selectedCallBack(cubeIndex:number, groupId:number, cubeObject:Cube){
        cubeObject.rotation.x += .015;
        cubeObject.position.z += 2;
        cubeObject.hslFront.x += .02;
        cubeObject.hslFront.y += .05;
        cubeObject.hslFront.z -= .001;
        cubeObject.hslBack.x += .02;
        cubeObject.hslBack.y += .05;
        cubeObject.hslBack.z -= .001;
        cubeObject.interact = 3;
    }

    function mapToCubes(map:Function, cubeIndex?:number){
        let total:number = gridSizes.length;
        let iterateId:number = 0;
        if(cubeIndex > 0 && cubeIndex <= gridSizes.length){
            total = cubeIndex; iterateId = cubeIndex-1;
        }
        for (let i = iterateId; i < total; i++) {
            const xgrid:number = gridSizes[i][0];
            const ygrid:number = gridSizes[i][1];
            let c:number = 0;
            for (let o = 0; o < xgrid; o++) {
                for (let j = ygrid; j > 0; j--) { map(cubes[i][c], i, c, o, j); c++; } }
        }
    }

    function updateHsl(c:Cube, val:number, amp?:THREE.Vector3):void{
        let ampD = new THREE.Vector3(3, 1, 1);
        if(amp){ampD.copy(amp);}
        let sat = .7;
        let light = .7;
        if(val > .22 && val < .38){
            sat = 1; light = .2;
        }
        c.hslFront.set((val * ampD.x) / Math.PI, sat * ampD.y, light * ampD.z);
        c.hslBack.set(((val - .5) * ampD.x) / Math.PI, .9, .9);
    }

    function setCubeGroupVisible(cubeIndex: number, visible: boolean, half?: boolean):void{
        for (let j = 0; j < cubeCounts[cubeIndex-1]; j++) {
            if(half === undefined){
                cubes[cubeIndex-1][j].visible = visible;
            }else{
                const lenT = gridSizes[cubeIndex-1][1];
                let show = visible;
                if(j % lenT >= lenT/2){show = !show;}
                if(half){ show = !show; }
                cubes[cubeIndex-1][j].visible = show;
            }
        }
    }
    
</script>

<Loader/>

<div on:mousemove={handleMousemove} >
    <ThreeCanvas {totalW} {totalH} {gridSizes} {cubes} {camera} {objects} {textures} {groupObjects} {selectedCallBack}/>
</div>

<!-- <VideoTag src="/media/sintel.mp4"/> -->
<!-- <VideoTag src="/media/led-products.mp4"/> -->
<!-- <VideoTag src="/media/caminandes-llamigos.mp4"/> -->
<!-- <VideoTag src="/media/videos/hepp-dot-pro_-_intro-video.mp4"/> -->
